

var Settings = function () {
    this.defaultBlock = 'latest';
    this.defaultAccount = undefined;
};

module.exports = Settings;




//////////////////
// WEBPACK FOOTER
// ../~/web3/lib/web3/settings.js
// module id = 466
// module chunks = 0